

// Import Icon
import Iconclock from "../../assets/img/icon/clock.png"
import IconMap from "../../assets/img/icon/map.png"
import IconDate from "../../assets/img/icon/date.png"




export const EventsDatas = [
 
  {
    heading:"Badminton club night — all levels welcome",
    category:"#Badminton",
    para:`Year-round hall sessions with coaching corners for juniors and rotation play for adults. Check the newsletter for racket-share options.`,
    IconClock:Iconclock,
    IconMap:IconMap,
    IconDate:IconDate
  },
  {
    heading:"Integration Q&A — health, school & summer",
    category:"#Integration",
    para:`Parents’ session with practical tips and peer stories about making Swedish institutions feel less overwhelming.`,
    IconClock:Iconclock,
    IconMap:IconMap,
    IconDate:IconDate
  },
  {
    heading:"Outdoor social — seasonal cricket & picnic",
    category:"#Seasonal",
    para:`When the weather allows: soft cricket on grass, plus news about football blocks and swim session dates.`,
    IconClock:Iconclock,
    IconMap:IconMap,
    IconDate:IconDate
  }
   
]
